import { API } from "@/lib/api";
import { getHiveflowConfig } from "@/lib/environment";
import { APP_BUILD, APP_VERSION } from "@/version";

function apiLabel() {
  try {
    const url = new URL(API, window.location.origin);
    return url.host + url.pathname.replace(/\/$/, "");
  } catch {
    return API || "/api";
  }
}

export default function EnvironmentBadge({ align = "center" }) {
  const cfg = getHiveflowConfig();
  if (cfg.appEnv === "production") return null;

  const label = cfg.appEnv === "beta" ? "Beta" : "Development";
  const mode = cfg.mobileMode ? "mobile" : "web";
  const justify = align === "left" ? "justify-start" : "justify-center";

  return (
    <div className={`flex ${justify} pt-2`} data-testid="environment-badge">
      <div className="inline-flex max-w-full flex-col gap-0.5 rounded-lg border border-zinc-200 bg-zinc-50 px-3 py-2 text-[11px] leading-tight text-zinc-500">
        <div className="font-bold uppercase tracking-wider text-zinc-700">{label} · {mode}</div>
        <div className="truncate">Versie: v{APP_VERSION} · build {APP_BUILD}</div>
        <div className="truncate">API: {apiLabel()}</div>
      </div>
    </div>
  );
}
